import React from "react";
import {
    FaMusic,
    FaGamepad,
    FaVideo,
    FaCoins,
    FaUsers,
    FaImage,
    FaIdCard,
    FaBuilding,
} from "react-icons/fa";

function Possibilities() {
    const services = [
        {
            icon: <FaMusic />,
            title: "Web3 Music Platform",
            desc: "A decentralized music streaming service that enables artists to distribute their music directly to fans, ensuring fair compensation and greater control over their content.",
        },
        {
            icon: <FaGamepad />,
            title: "Web3 Gaming Platform",
            desc: "A decentralized gaming ecosystem that allows players to earn cryptocurrency and trade in-game assets, creating a play-to-earn model and enhancing player engagement.",
        },
        {
            icon: <FaVideo />,
            title: "Web3 Video Streaming Platform",
            desc: "A decentralized video sharing platform that enables content creators to upload and monetize their videos without relying on traditional advertising models, offering viewers an ad-free experience.",
        },
        {
            icon: <FaCoins />,
            title: "Web3 Finance Platform",
            desc: "A decentralized finance (DeFi) platform that offers services like lending, borrowing, and yield farming, allowing users to manage their assets without intermediaries.",
        },
        {
            icon: <FaUsers />,
            title: "Web3 Social Media Platform",
            desc: "A decentralized social network that prioritizes user privacy and data ownership, enabling users to connect and share content without centralized control.",
        },
        {
            icon: <FaImage />,
            title: "Web3 NFT Marketplace",
            desc: "A decentralized marketplace for creating, buying, and selling non-fungible tokens (NFTs), providing artists and collectors a platform for digital art and collectibles.",
        },
        {
            icon: <FaIdCard />,
            title: "Web3 Identity Verification Platform",
            desc: "A decentralized identity management solution that allows users to verify their identity securely without sharing personal data, enhancing privacy and security.",
        },
        {
            icon: <FaBuilding />,
            title: "Web3 Real Estate Platform",
            desc: "A decentralized platform for buying, selling, and leasing properties using blockchain technology, enabling transparent transactions and fractional ownership options.",
        },
    ];

    return (
        <div className="default-padding" style={{ background: "#f8fafc" }}>
            <div className="container">
                {/* Heading */}
                <div className="text-center mb-5">
                    <h4 className="sub-title text-primary">Services</h4>
                    <h2 className="title">Explore Wide Possibilities of Building Web3 Applications</h2>
                    <p className="text-muted mx-auto" style={{ maxWidth: "650px" }}>
                        Embrace the limitless opportunities that Web3 offers to redefine traditional models and create value-driven applications for your audience.
                    </p>
                </div>

                {/* Cards */}
                <div className="row g-4">
                    {services.map((item, index) => (
                        <div className="col-lg-3 col-md-6" key={index}>
                            <div className="nft-card p-4 h-100 text-center">
                                <div className="icon-box mx-auto mb-3">{item.icon}</div>

                                <h2 className="text-bold">{item.title}</h2>
                                <p>{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Styles */}
            <style>{`
        .nft-card {
          background: #ffffff;
          border-radius: 20px;
          border: 1px solid #e2e8f0;
          transition: all 0.35s ease;
          position: relative;
          overflow: hidden;
        }

        .nft-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 25px 60px rgba(0,0,0,0.08);
        }

        .icon-box {
          width: 70px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(59,130,246,0.1);
          color: #3b82f6;
          border-radius: 18px;
          font-size: 26px;
          transition: 0.3s;
        }

        .nft-card:hover .icon-box {
          background: #3b82f6;
          color: #fff;
          transform: scale(1.1);
        }

        h5 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 8px;
          color: #0f172a;
        }

        p {
          font-size: 14px;
          color: #64748b;
          margin: 0;
          line-height: 1.6;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .icon-box {
            width: 60px;
            height: 60px;
          }
        }
      `}</style>
        </div>
    );
}

export default Possibilities;
